export const selectGlobalApiFailure = (state) => state.notifications.globalError



// WEBPACK FOOTER //
// ./src/services/notifications/selectors.js